import {
    IntegrationActionTypes,
    DisconnectIntegrationFailureActionType,
    DisconnectIntegrationRequestActionType,
    DisconnectIntegrationSuccessActionType,
    GetGoogleSheetsAuthURLFailureActionType,
    GetGoogleSheetsAuthURLRequestActionType,
    GetGoogleSheetsAuthURLSuccessActionType,
    GetGoogleSheetsFailureActionType,
    GetGoogleSheetsRequestActionType,
    GetGoogleSheetsSuccessActionType,
    GetGoogleSheetWorksheetsFailureActionType,
    GetGoogleSheetWorksheetsRequestActionType,
    GetGoogleSheetWorksheetsSuccessActionType,
    GetHubspotAuthURLFailureActionType,
    GetHubspotAuthURLRequestActionType,
    GetHubspotAuthURLSuccessActionType,
    GetHubspotDataFailureActionType,
    GetHubspotDataRequestActionType,
    GetHubspotDataSuccessActionType,
    GetHubspotStatusFailureActionType,
    GetHubspotStatusRequestActionType,
    GetHubspotStatusSuccessActionType,
    GetHubspotTablesFailureActionType,
    GetHubspotTablesRequestActionType,
    GetHubspotTablesSuccessActionType,
    GetIntegrationStatusesFailureActionType,
    GetIntegrationStatusesRequestActionType,
    GetIntegrationStatusesSuccessActionType,
    GetZapierAuthURLFailureActionType,
    GetZapierAuthURLRequestActionType,
    GetZapierAuthURLSuccessActionType,
    UpdateGoogleSheetsConfigFailureActionType,
    UpdateGoogleSheetsConfigRequestActionType,
    UpdateGoogleSheetsConfigSuccessActionType,
    UpdateHubspotPropertyFailureActionType,
    UpdateHubspotPropertyRequestActionType,
    UpdateHubspotPropertySuccessActionType,
    GetMailchimpAuthURLRequestActionType,
    GetMailchimpAuthURLSuccessActionType,
    GetMailchimpAuthURLFailureActionType,
    UpdateMailchimpConfigRequestActionType,
    UpdateMailchimpConfigSuccessActionType,
    UpdateMailchimpConfigFailureActionType,
    GetMailchimpRequestActionType,
    GetMailchimpSuccessActionType,
    GetMailchimpFailureActionType,
    GetMailchimpSelectedFieldsRequestActionType,
    GetMailchimpSelectedFieldsSuccessActionType,
    GetMailchimpSelectedFieldsFailureActionType,
    GetZapierTokensRequestActionType,
    GetZapierTokensSuccessActionType,
    GetZapierTokensFailureActionType,
    DisconnectZapierRequestActionType,
    DisconnectZapierSuccessActionType,
    DisconnectZapierFailureActionType,
    GetZapierZapsRequestActionType,
    GetZapierZapsSuccessActionType,
    GetZapierZapsFailureActionType,
} from "./types";

import { ActionCreator } from "../types/store-types";

export const getZapierAuthURLRequest: ActionCreator<GetZapierAuthURLRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_ZAPIER_AUTH_URL_REQUEST,
    payload,
});

export const getZapierAuthURLSuccess: ActionCreator<GetZapierAuthURLSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_ZAPIER_AUTH_URL_SUCCESS,
    payload,
});

export const getZapierAuthURLFailure: ActionCreator<GetZapierAuthURLFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_ZAPIER_AUTH_URL_FAILURE,
    payload,
});
export const getZapierZapsRequest: ActionCreator<GetZapierZapsRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_ZAPIER_ZAPS_REQUEST,
    payload,
});

export const getZapierZapsSuccess: ActionCreator<GetZapierZapsSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_ZAPIER_ZAPS_SUCCESS,
    payload,
});

export const getZapierZapsFailure: ActionCreator<GetZapierZapsFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_ZAPIER_ZAPS_FAILURE,
    payload,
});
export const getZapierTokensRequest: ActionCreator<GetZapierTokensRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_ZAPIER_TOKENS_REQUEST,
    payload,
});
export const getZapierTokensSuccess: ActionCreator<GetZapierTokensSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_ZAPIER_TOKENS_SUCCESS,
    payload,
});

export const getZapierTokensFailure: ActionCreator<GetZapierTokensFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_ZAPIER_TOKENS_FAILURE,
    payload,
});

export const disconnectZapierRequest: ActionCreator<DisconnectZapierRequestActionType> = payload => ({
    type: IntegrationActionTypes.DISCONNECT_ZAPIER_REQUEST,
    payload,
});
export const disconnectZapierSuccess: ActionCreator<DisconnectZapierSuccessActionType> = payload => ({
    type: IntegrationActionTypes.DISCONNECT_ZAPIER_SUCCESS,
    payload,
});
export const disconnectZapierFailure: ActionCreator<DisconnectZapierFailureActionType> = payload => ({
    type: IntegrationActionTypes.DISCONNECT_ZAPIER_FAILURE,
    payload,
});
export const getHubspotAuthURLRequest: ActionCreator<GetHubspotAuthURLRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_HUBSPOT_AUTH_URL_REQUEST,
    payload,
});
export const getHubspotAuthURLSuccess: ActionCreator<GetHubspotAuthURLSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_HUBSPOT_AUTH_URL_SUCCESS,
    payload,
});

export const getHubspotAuthURLFailure: ActionCreator<GetHubspotAuthURLFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_HUBSPOT_AUTH_URL_FAILURE,
    payload,
});

export const getHubspotDataRequest: ActionCreator<GetHubspotDataRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_HUBSPOT_DATA_REQUEST,
    payload,
});
export const getHubspotDataSuccess: ActionCreator<GetHubspotDataSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_HUBSPOT_DATA_SUCCESS,
    payload,
});

export const getHubspotDataFailure: ActionCreator<GetHubspotDataFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_HUBSPOT_DATA_FAILURE,
    payload,
});

export const getHubspotStatusRequest: ActionCreator<GetHubspotStatusRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_HUBSPOT_STATUS_REQUEST,
    payload,
});
export const getHubspotStatusSuccess: ActionCreator<GetHubspotStatusSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_HUBSPOT_STATUS_SUCCESS,
    payload,
});

export const getHubspotStatusFailure: ActionCreator<GetHubspotStatusFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_HUBSPOT_STATUS_FAILURE,
    payload,
});

export const updateHubspotPropertyRequest: ActionCreator<UpdateHubspotPropertyRequestActionType> = payload => ({
    type: IntegrationActionTypes.UPDATE_HUBSPOT_PROPERTY_REQUEST,
    payload,
});
export const updateHubspotPropertySuccess: ActionCreator<UpdateHubspotPropertySuccessActionType> = payload => ({
    type: IntegrationActionTypes.UPDATE_HUBSPOT_PROPERTY_SUCCESS,
    payload,
});

export const updateHubspotPropertyFailure: ActionCreator<UpdateHubspotPropertyFailureActionType> = payload => ({
    type: IntegrationActionTypes.UPDATE_HUBSPOT_PROPERTY_FAILURE,
    payload,
});
export const getHubspotTablesRequest: ActionCreator<GetHubspotTablesRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_HUBSPOT_TABLES_REQUEST,
    payload,
});
export const getHubspotTablesSuccess: ActionCreator<GetHubspotTablesSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_HUBSPOT_TABLES_SUCCESS,
    payload,
});

export const getHubspotTablesFailure: ActionCreator<GetHubspotTablesFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_HUBSPOT_TABLES_FAILURE,
    payload,
});

export const getGoogleSheetsAuthURLRequest: ActionCreator<GetGoogleSheetsAuthURLRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_GOOGLESHEETS_AUTH_URL_REQUEST,
    payload,
});
export const getGoogleSheetsAuthURLSuccess: ActionCreator<GetGoogleSheetsAuthURLSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_GOOGLESHEETS_AUTH_URL_SUCCESS,
    payload,
});

export const getGoogleSheetsAuthURLFailure: ActionCreator<GetGoogleSheetsAuthURLFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_GOOGLESHEETS_AUTH_URL_FAILURE,
    payload,
});

export const getGoogleSheetsRequest: ActionCreator<GetGoogleSheetsRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_GOOGLESHEETS_REQUEST,
    payload,
});

export const getGoogleSheetsSuccess: ActionCreator<GetGoogleSheetsSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_GOOGLESHEETS_SUCCESS,
    payload,
});

export const getGoogleSheetsFailure: ActionCreator<GetGoogleSheetsFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_GOOGLESHEETS_FAILURE,
    payload,
});

export const updateGoogleSheetsConfigRequest: ActionCreator<UpdateGoogleSheetsConfigRequestActionType> = payload => ({
    type: IntegrationActionTypes.UPDATE_GOOGLE_SHEETS_CONFIG_REQUEST,
    payload,
});

export const updateGoogleSheetsConfigSuccess: ActionCreator<UpdateGoogleSheetsConfigSuccessActionType> = payload => ({
    type: IntegrationActionTypes.UPDATE_GOOGLE_SHEETS_CONFIG_SUCCESS,
    payload,
});

export const updateGoogleSheetsConfigFailure: ActionCreator<UpdateGoogleSheetsConfigFailureActionType> = payload => ({
    type: IntegrationActionTypes.UPDATE_GOOGLE_SHEETS_CONFIG_FAILURE,
    payload,
});

export const getGoogleSheetWorksheetsRequest: ActionCreator<GetGoogleSheetWorksheetsRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_GOOGLE_SHEET_WORKSHEETS_REQUEST,
    payload,
});
export const getGoogleSheetWorksheetsSuccess: ActionCreator<GetGoogleSheetWorksheetsSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_GOOGLE_SHEET_WORKSHEETS_SUCCESS,
    payload,
});

export const getGoogleSheetWorksheetsFailure: ActionCreator<GetGoogleSheetWorksheetsFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_GOOGLE_SHEET_WORKSHEETS_FAILURE,
    payload,
});

export const disconnectIntegrationRequest: ActionCreator<DisconnectIntegrationRequestActionType> = payload => ({
    type: IntegrationActionTypes.DISCONNECT_INTEGRATION_REQUEST,
    payload,
});

export const disconnectIntegrationSuccess: ActionCreator<DisconnectIntegrationSuccessActionType> = payload => ({
    type: IntegrationActionTypes.DISCONNECT_INTEGRATION_SUCCESS,
    payload,
});

export const disconnectIntegrationFailure: ActionCreator<DisconnectIntegrationFailureActionType> = payload => ({
    type: IntegrationActionTypes.DISCONNECT_INTEGRATION_FAILURE,
    payload,
});

export const getIntegrationStatusesRequest: ActionCreator<GetIntegrationStatusesRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_INTEGRATION_STATUSES_REQUEST,
    payload,
});

export const getIntegrationStatusesSuccess: ActionCreator<GetIntegrationStatusesSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_INTEGRATION_STATUSES_SUCCESS,
    payload,
});

export const getIntegrationStatusesFailure: ActionCreator<GetIntegrationStatusesFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_INTEGRATION_STATUSES_FAILURE,
    payload,
});
export const getMailchimpAuthURLRequest: ActionCreator<GetMailchimpAuthURLRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_MAILCHIMP_AUTH_URL_REQUEST,
    payload,
});

export const getMailchimpAuthURLSuccess: ActionCreator<GetMailchimpAuthURLSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_MAILCHIMP_AUTH_URL_SUCCESS,
    payload,
});

export const getMailchimpAuthURLFailure: ActionCreator<GetMailchimpAuthURLFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_MAILCHIMP_AUTH_URL_FAILURE,
    payload,
});

export const updateMailchimpConfigRequest: ActionCreator<UpdateMailchimpConfigRequestActionType> = payload => ({
    type: IntegrationActionTypes.UPDATE_MAILCHIMP_CONFIG_REQUEST,
    payload,
});
export const updateMailchimpConfigSuccess: ActionCreator<UpdateMailchimpConfigSuccessActionType> = payload => ({
    type: IntegrationActionTypes.UPDATE_MAILCHIMP_CONFIG_SUCCESS,
    payload,
});
export const updateMailchimpConfigFailure: ActionCreator<UpdateMailchimpConfigFailureActionType> = payload => ({
    type: IntegrationActionTypes.UPDATE_MAILCHIMP_CONFIG_FAILURE,
    payload,
});

export const getMailchimpListRequest: ActionCreator<GetMailchimpRequestActionType> = payload => ({
    type: IntegrationActionTypes.GET_MAILCHIMP_REQUEST,
    payload,
});
export const getMailchimpListSuccess: ActionCreator<GetMailchimpSuccessActionType> = payload => ({
    type: IntegrationActionTypes.GET_MAILCHIMP_SUCCESS,
    payload,
});
export const getMailchimpListsFailure: ActionCreator<GetMailchimpFailureActionType> = payload => ({
    type: IntegrationActionTypes.GET_MAILCHIMP_FAILURE,
    payload,
});

export const getMailchimpSelectedFieldsRequest: ActionCreator<
    GetMailchimpSelectedFieldsRequestActionType
> = payload => ({
    type: IntegrationActionTypes.GET_MAILCHIMP_SELECTED_FIELDS_REQUEST,
    payload,
});
export const getMailchimpSelectedFieldsSuccess: ActionCreator<
    GetMailchimpSelectedFieldsSuccessActionType
> = payload => ({
    type: IntegrationActionTypes.GET_MAILCHIMP_SELECTED_FIELDS_SUCCESS,
    payload,
});
export const getMailchimpSelectedFieldsFailure: ActionCreator<
    GetMailchimpSelectedFieldsFailureActionType
> = payload => ({
    type: IntegrationActionTypes.GET_MAILCHIMP_SELECTED_FIELDS_FAILURE,
    payload,
});
